"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var query_string_1 = __importDefault(require("query-string"));
var react_1 = __importStar(require("react"));
var react_query_1 = require("react-query");
var react_router_dom_1 = require("react-router-dom");
var store_credit_1 = require("../../misc/store-credit");
var api_1 = require("./api");
var callout_1 = require("./components/callout");
var CancelSubscription = __importStar(require("./mutations/cancel-subscription"));
var add_bundles_1 = __importDefault(require("./sections/add-bundles"));
var bundles_1 = __importDefault(require("./sections/bundles"));
var diaper_fund_1 = __importDefault(require("./sections/diaper-fund"));
var orders_1 = __importDefault(require("./sections/orders"));
var payment_1 = __importDefault(require("./sections/payment"));
var profile_1 = __importDefault(require("./sections/profile"));
var referrals_1 = __importDefault(require("./sections/referrals"));
var returns_1 = __importDefault(require("./sections/returns"));
var yotpo_rewards_1 = __importDefault(require("./sections/yotpo-rewards"));
/**
 * These aren't the only possible Brightback decisions, but they're the only ones handled by this component
 */
var BrightbackDecision;
(function (BrightbackDecision) {
    BrightbackDecision["CANCEL"] = "c";
})(BrightbackDecision || (BrightbackDecision = {}));
/**
 * Query string parameters that this component "owns"
 */
var BrightbackDecisionParam;
(function (BrightbackDecisionParam) {
    /** The decision that the user made in Brightback. */
    BrightbackDecisionParam["BRIGHTBACK_DECISION"] = "bbd";
    /** The subscription id of the subscription to which the decision applies. */
    BrightbackDecisionParam["SUBSCRIPTION_ID"] = "sub";
    /** The customer's comments about their decision to cancel. */
    BrightbackDecisionParam["COMMENTS"] = "feedback";
    /** The reason that the customer wanted to cancel their subscription. */
    BrightbackDecisionParam["REASON"] = "reason";
})(BrightbackDecisionParam || (BrightbackDecisionParam = {}));
var AccountPage = function (_a) {
    // this page handles the return URL for Brightback cancellation decisions, so we check if the user has come from Brightback with the intent to cancel here
    var _b, _c, _d, _e;
    var groupedSubscriptions = _a.groupedSubscriptions, customerData = _a.customerData;
    var cancelSubscriptionMutation = (0, react_query_1.useMutation)("cancelSubscription", function (variables) {
        return (0, api_1.getSubscriptionAPIClient)().request(CancelSubscription.CANCEL_SUBSCRIPTION, variables);
    });
    var reactRouterLocation = (0, react_router_dom_1.useLocation)();
    var history = (0, react_router_dom_1.useHistory)();
    var callout = (0, callout_1.useCallout)().callout;
    var queryClient = (0, react_query_1.useQueryClient)();
    (0, react_1.useEffect)(function () {
        var checkAndHandleBrightbackDecision = function () { return __awaiter(void 0, void 0, void 0, function () {
            var queryParams;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParams = query_string_1.default.parse(reactRouterLocation.search);
                        if (!isBrightbackDecisionParams(queryParams)) return [3 /*break*/, 2];
                        return [4 /*yield*/, handleBrightbackDecision(queryParams)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        checkAndHandleBrightbackDecision().catch(function (error) {
            console.error(error);
            callout.alert('There was a problem cancelling your subscription. Please contact Customer Service at 1-888-860-6888.');
            removeBrightbackQueryParams();
        });
        return function () {
            removeBrightbackQueryParams();
        };
    }, []);
    /**
     * Handle query parameters that indicate a customer has made a decision within Brightback about whether or not to cancel a subscription.
     */
    var handleBrightbackDecision = function (params) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    // if the query params don't indicate a decision to cancel from Brightback, don't cancel
                    if (params[BrightbackDecisionParam.BRIGHTBACK_DECISION] !== BrightbackDecision.CANCEL)
                        return [2 /*return*/];
                    return [4 /*yield*/, cancelSubscriptionMutation.mutateAsync({
                            comments: params[BrightbackDecisionParam.COMMENTS],
                            reason: params[BrightbackDecisionParam.REASON] || 'Other',
                            subscriptionId: parseInt(params[BrightbackDecisionParam.SUBSCRIPTION_ID], 10),
                            decisionIsFromBrightback: true,
                        })];
                case 1:
                    _a.sent();
                    callout.success('Your subscription has been cancelled.');
                    // the order of calling removeBrightbackQueryParams and invalidateQueries matters because invalidateQueries causes some parent component to rerender this
                    // component, so the Brightback query parameters need to have been removed before that happens or else we'll try to handle the Brightback decision again
                    // on the rerender
                    removeBrightbackQueryParams();
                    return [4 /*yield*/, queryClient.invalidateQueries('getCustomerSubscriptions')];
                case 2:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    /**
     * Remove all query string params from URL that this component "owns"
     */
    var removeBrightbackQueryParams = function () {
        var e_1, _a;
        var queryParams = query_string_1.default.parse(reactRouterLocation.search);
        try {
            for (var _b = __values(Object.values(BrightbackDecisionParam)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var queryParam = _c.value;
                delete queryParams[queryParam];
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        history.replace({
            search: query_string_1.default.stringify(queryParams),
        });
    };
    var isLoggedIn = !!((_b = window.customer) === null || _b === void 0 ? void 0 : _b.id);
    var customerCreditAccountQuery = (0, store_credit_1.useCustomerCreditAccount)({ enabled: !!isLoggedIn });
    var customerStoreCreditBalance = (function () {
        var _a;
        if (customerCreditAccountQuery.isLoading)
            return undefined;
        if (!((_a = customerCreditAccountQuery.data) === null || _a === void 0 ? void 0 : _a.account.creditAccount))
            return 0;
        return Number(customerCreditAccountQuery.data.account.creditAccount.available_balance);
    })();
    if (!customerData) {
        return null;
    }
    // for new bundles, simply pick the first address ID you can find and get its address id and discount code
    var referenceGroupedSubscriptionForNewBundles = groupedSubscriptions === null || groupedSubscriptions === void 0 ? void 0 : groupedSubscriptions.find(function (g) { var _a; return (_a = g.address) === null || _a === void 0 ? void 0 : _a.id; });
    var addressIdForNewBundles = (_c = referenceGroupedSubscriptionForNewBundles === null || referenceGroupedSubscriptionForNewBundles === void 0 ? void 0 : referenceGroupedSubscriptionForNewBundles.address) === null || _c === void 0 ? void 0 : _c.id;
    var discountCodeForNewBundles = (_e = (_d = referenceGroupedSubscriptionForNewBundles === null || referenceGroupedSubscriptionForNewBundles === void 0 ? void 0 : referenceGroupedSubscriptionForNewBundles.address) === null || _d === void 0 ? void 0 : _d.discount) === null || _e === void 0 ? void 0 : _e.code;
    return (react_1.default.createElement("div", { className: 'grid-container' },
        react_1.default.createElement("div", { className: 'account-header' },
            react_1.default.createElement("h5", { className: 'padding-top-5', style: { fontSize: '20px' } },
                "Hello ",
                customerData.first_name,
                "!")),
        react_1.default.createElement(bundles_1.default, { groupedSubscriptions: groupedSubscriptions, customerData: customerData }),
        addressIdForNewBundles && react_1.default.createElement(add_bundles_1.default, { addressId: addressIdForNewBundles, discountCode: discountCodeForNewBundles }),
        react_1.default.createElement("div", { className: 'h-4' }),
        react_1.default.createElement("div", { className: 'space-y-4' },
            react_1.default.createElement(orders_1.default, null),
            window.accountApp.settings.enableReturns && react_1.default.createElement(returns_1.default, null),
            react_1.default.createElement(payment_1.default, { customerStoreCreditBalance: customerStoreCreditBalance }),
            react_1.default.createElement(referrals_1.default, { customerId: customerData.id }),
            window.accountApp.settings.enableYotpoBlock && react_1.default.createElement(yotpo_rewards_1.default, null),
            react_1.default.createElement(profile_1.default, null),
            react_1.default.createElement(diaper_fund_1.default, { email: customerData.email })),
        react_1.default.createElement("div", { className: 'padding-vertical-10 padding-horizontal-5' },
            react_1.default.createElement("a", { className: 'text-underline font-bold', href: '/account/logout' }, "Logout"))));
};
exports.default = AccountPage;
var isBrightbackDecisionParams = function (value) {
    var typedValue = value;
    return (Object.values(BrightbackDecision).includes(typedValue[BrightbackDecisionParam.BRIGHTBACK_DECISION]) &&
        typedValue[BrightbackDecisionParam.SUBSCRIPTION_ID] !== undefined &&
        typedValue[BrightbackDecisionParam.SUBSCRIPTION_ID] !== null);
};
